/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StaffAreaRouteImport } from './routes/_staff-area'
import { Route as AccountRecoveryRouteImport } from './routes/account-recovery'
import { Route as AccountSecurityAlertRouteImport } from './routes/account-security-alert'
import { Route as AccountSetupRouteImport } from './routes/account-setup'
import { Route as ApplicantRouteImport } from './routes/applicant'
import { Route as NoAccessRouteImport } from './routes/no-access'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as StaffRouteImport } from './routes/staff'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as WebsiteRouteImport } from './routes/website'
import { Route as StaffAreaAccountRouteImport } from './routes/_staff-area/account'
import { Route as StaffAreaQuestionBankRouteImport } from './routes/_staff-area/question-bank'
import { Route as StaffAreaTeamRouteImport } from './routes/_staff-area/team'
import { Route as ApplicantHomeRouteImport } from './routes/applicant/home'
import { Route as ApplyRoundIdRouteImport } from './routes/apply.$roundId'
import { Route as RoundsRoundIdRouteImport } from './routes/rounds.$roundId'
import { Route as StaffApplicationsRouteImport } from './routes/staff/applications'
import { Route as StaffCompetenciesRouteImport } from './routes/staff/competencies'
import { Route as StaffDashboardRouteImport } from './routes/staff/dashboard'
import { Route as StaffQuestionsRouteImport } from './routes/staff/questions'
import { Route as StaffReportingRouteImport } from './routes/staff/reporting'
import { Route as StaffRoundsRouteImport } from './routes/staff/rounds'
import { Route as StaffSettingsRouteImport } from './routes/staff/settings'
import { Route as StaffAreaCohortsIndexRouteImport } from './routes/_staff-area/cohorts.index'
import { Route as StaffAreaCohortsCohortIdRouteImport } from './routes/_staff-area/cohorts.$cohortId'
import { Route as ApplicantApplicationsApplicationIdRouteImport } from './routes/applicant.applications.$applicationId'
import { Route as ApplyRoundIdRegisterRouteImport } from './routes/apply_.$roundId.register'
import { Route as StaffRoundsCreateRouteImport } from './routes/staff_.rounds.create'
import { Route as StaffAreaCohortsCohortIdIndexRouteImport } from './routes/_staff-area/cohorts.$cohortId.index'
import { Route as StaffAreaCohortsCohortIdSettingsRouteImport } from './routes/_staff-area/cohorts.$cohortId.settings'
import { Route as ApplicantApplicationsApplicationIdRespondRouteImport } from './routes/applicant.applications.$applicationId_.respond'
import { Route as StaffRoundsRoundIdApplicationsRouteImport } from './routes/staff.rounds_.$roundId.applications'
import { Route as StaffRoundsRoundIdQueueRouteImport } from './routes/staff.rounds_.$roundId.queue'
import { Route as StaffRoundsRoundIdWaitingRouteImport } from './routes/staff.rounds_.$roundId.waiting'
import { Route as StaffRoundsRoundIdSetupRouteImport } from './routes/staff_.rounds.$roundId.setup'
import { Route as StaffAreaCohortsCohortIdAppelsAppelIdRouteImport } from './routes/_staff-area/cohorts.$cohortId.appels.$appelId'
import { Route as StaffRoundsRoundIdApplicationsApplicationIdRouteImport } from './routes/staff.rounds_.$roundId.applications_.$applicationId'
import { Route as StaffAreaCohortsCohortIdAppelsAppelIdIndexRouteImport } from './routes/_staff-area/cohorts.$cohortId.appels.$appelId.index'
import { Route as StaffAreaCohortsCohortIdAppelsAppelIdEligibilityRouteImport } from './routes/_staff-area/cohorts.$cohortId.appels.$appelId.eligibility'
import { Route as StaffAreaCohortsCohortIdAppelsAppelIdProgrammeRouteImport } from './routes/_staff-area/cohorts.$cohortId.appels.$appelId.programme'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffAreaRoute = StaffAreaRouteImport.update({
  id: '/_staff-area',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRecoveryRoute = AccountRecoveryRouteImport.update({
  id: '/account-recovery',
  path: '/account-recovery',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountSecurityAlertRoute = AccountSecurityAlertRouteImport.update({
  id: '/account-security-alert',
  path: '/account-security-alert',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountSetupRoute = AccountSetupRouteImport.update({
  id: '/account-setup',
  path: '/account-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplicantRoute = ApplicantRouteImport.update({
  id: '/applicant',
  path: '/applicant',
  getParentRoute: () => rootRouteImport,
} as any)
const NoAccessRoute = NoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffRoute = StaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const WebsiteRoute = WebsiteRouteImport.update({
  id: '/website',
  path: '/website',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffAreaAccountRoute = StaffAreaAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => StaffAreaRoute,
} as any)
const StaffAreaQuestionBankRoute = StaffAreaQuestionBankRouteImport.update({
  id: '/question-bank',
  path: '/question-bank',
  getParentRoute: () => StaffAreaRoute,
} as any)
const StaffAreaTeamRoute = StaffAreaTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => StaffAreaRoute,
} as any)
const ApplicantHomeRoute = ApplicantHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => ApplicantRoute,
} as any)
const ApplyRoundIdRoute = ApplyRoundIdRouteImport.update({
  id: '/apply/$roundId',
  path: '/apply/$roundId',
  getParentRoute: () => rootRouteImport,
} as any)
const RoundsRoundIdRoute = RoundsRoundIdRouteImport.update({
  id: '/rounds/$roundId',
  path: '/rounds/$roundId',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffApplicationsRoute = StaffApplicationsRouteImport.update({
  id: '/applications',
  path: '/applications',
  getParentRoute: () => StaffRoute,
} as any)
const StaffCompetenciesRoute = StaffCompetenciesRouteImport.update({
  id: '/competencies',
  path: '/competencies',
  getParentRoute: () => StaffRoute,
} as any)
const StaffDashboardRoute = StaffDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => StaffRoute,
} as any)
const StaffQuestionsRoute = StaffQuestionsRouteImport.update({
  id: '/questions',
  path: '/questions',
  getParentRoute: () => StaffRoute,
} as any)
const StaffReportingRoute = StaffReportingRouteImport.update({
  id: '/reporting',
  path: '/reporting',
  getParentRoute: () => StaffRoute,
} as any)
const StaffRoundsRoute = StaffRoundsRouteImport.update({
  id: '/rounds',
  path: '/rounds',
  getParentRoute: () => StaffRoute,
} as any)
const StaffSettingsRoute = StaffSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => StaffRoute,
} as any)
const StaffAreaCohortsIndexRoute = StaffAreaCohortsIndexRouteImport.update({
  id: '/cohorts/',
  path: '/cohorts/',
  getParentRoute: () => StaffAreaRoute,
} as any)
const StaffAreaCohortsCohortIdRoute =
  StaffAreaCohortsCohortIdRouteImport.update({
    id: '/cohorts/$cohortId',
    path: '/cohorts/$cohortId',
    getParentRoute: () => StaffAreaRoute,
  } as any)
const ApplicantApplicationsApplicationIdRoute =
  ApplicantApplicationsApplicationIdRouteImport.update({
    id: '/applications/$applicationId',
    path: '/applications/$applicationId',
    getParentRoute: () => ApplicantRoute,
  } as any)
const ApplyRoundIdRegisterRoute = ApplyRoundIdRegisterRouteImport.update({
  id: '/apply_/$roundId/register',
  path: '/apply/$roundId/register',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffRoundsCreateRoute = StaffRoundsCreateRouteImport.update({
  id: '/staff_/rounds/create',
  path: '/staff/rounds/create',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffAreaCohortsCohortIdIndexRoute =
  StaffAreaCohortsCohortIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAreaCohortsCohortIdRoute,
  } as any)
const StaffAreaCohortsCohortIdSettingsRoute =
  StaffAreaCohortsCohortIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StaffAreaCohortsCohortIdRoute,
  } as any)
const ApplicantApplicationsApplicationIdRespondRoute =
  ApplicantApplicationsApplicationIdRespondRouteImport.update({
    id: '/applications/$applicationId_/respond',
    path: '/applications/$applicationId/respond',
    getParentRoute: () => ApplicantRoute,
  } as any)
const StaffRoundsRoundIdApplicationsRoute =
  StaffRoundsRoundIdApplicationsRouteImport.update({
    id: '/rounds_/$roundId/applications',
    path: '/rounds/$roundId/applications',
    getParentRoute: () => StaffRoute,
  } as any)
const StaffRoundsRoundIdQueueRoute = StaffRoundsRoundIdQueueRouteImport.update({
  id: '/rounds_/$roundId/queue',
  path: '/rounds/$roundId/queue',
  getParentRoute: () => StaffRoute,
} as any)
const StaffRoundsRoundIdWaitingRoute =
  StaffRoundsRoundIdWaitingRouteImport.update({
    id: '/rounds_/$roundId/waiting',
    path: '/rounds/$roundId/waiting',
    getParentRoute: () => StaffRoute,
  } as any)
const StaffRoundsRoundIdSetupRoute = StaffRoundsRoundIdSetupRouteImport.update({
  id: '/staff_/rounds/$roundId/setup',
  path: '/staff/rounds/$roundId/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffAreaCohortsCohortIdAppelsAppelIdRoute =
  StaffAreaCohortsCohortIdAppelsAppelIdRouteImport.update({
    id: '/appels/$appelId',
    path: '/appels/$appelId',
    getParentRoute: () => StaffAreaCohortsCohortIdRoute,
  } as any)
const StaffRoundsRoundIdApplicationsApplicationIdRoute =
  StaffRoundsRoundIdApplicationsApplicationIdRouteImport.update({
    id: '/rounds_/$roundId/applications_/$applicationId',
    path: '/rounds/$roundId/applications/$applicationId',
    getParentRoute: () => StaffRoute,
  } as any)
const StaffAreaCohortsCohortIdAppelsAppelIdIndexRoute =
  StaffAreaCohortsCohortIdAppelsAppelIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAreaCohortsCohortIdAppelsAppelIdRoute,
  } as any)
const StaffAreaCohortsCohortIdAppelsAppelIdEligibilityRoute =
  StaffAreaCohortsCohortIdAppelsAppelIdEligibilityRouteImport.update({
    id: '/eligibility',
    path: '/eligibility',
    getParentRoute: () => StaffAreaCohortsCohortIdAppelsAppelIdRoute,
  } as any)
const StaffAreaCohortsCohortIdAppelsAppelIdProgrammeRoute =
  StaffAreaCohortsCohortIdAppelsAppelIdProgrammeRouteImport.update({
    id: '/programme',
    path: '/programme',
    getParentRoute: () => StaffAreaCohortsCohortIdAppelsAppelIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account-recovery': typeof AccountRecoveryRoute
  '/account-security-alert': typeof AccountSecurityAlertRoute
  '/account-setup': typeof AccountSetupRoute
  '/applicant': typeof ApplicantRouteWithChildren
  '/no-access': typeof NoAccessRoute
  '/reset-password': typeof ResetPasswordRoute
  '/staff': typeof StaffRouteWithChildren
  '/verify-email': typeof VerifyEmailRoute
  '/website': typeof WebsiteRoute
  '/account': typeof StaffAreaAccountRoute
  '/question-bank': typeof StaffAreaQuestionBankRoute
  '/team': typeof StaffAreaTeamRoute
  '/applicant/home': typeof ApplicantHomeRoute
  '/apply/$roundId': typeof ApplyRoundIdRoute
  '/rounds/$roundId': typeof RoundsRoundIdRoute
  '/staff/applications': typeof StaffApplicationsRoute
  '/staff/competencies': typeof StaffCompetenciesRoute
  '/staff/dashboard': typeof StaffDashboardRoute
  '/staff/questions': typeof StaffQuestionsRoute
  '/staff/reporting': typeof StaffReportingRoute
  '/staff/rounds': typeof StaffRoundsRoute
  '/staff/settings': typeof StaffSettingsRoute
  '/cohorts/$cohortId': typeof StaffAreaCohortsCohortIdRouteWithChildren
  '/applicant/applications/$applicationId': typeof ApplicantApplicationsApplicationIdRoute
  '/apply/$roundId/register': typeof ApplyRoundIdRegisterRoute
  '/staff/rounds/create': typeof StaffRoundsCreateRoute
  '/cohorts/': typeof StaffAreaCohortsIndexRoute
  '/cohorts/$cohortId/settings': typeof StaffAreaCohortsCohortIdSettingsRoute
  '/applicant/applications/$applicationId/respond': typeof ApplicantApplicationsApplicationIdRespondRoute
  '/staff/rounds/$roundId/applications': typeof StaffRoundsRoundIdApplicationsRoute
  '/staff/rounds/$roundId/queue': typeof StaffRoundsRoundIdQueueRoute
  '/staff/rounds/$roundId/waiting': typeof StaffRoundsRoundIdWaitingRoute
  '/staff/rounds/$roundId/setup': typeof StaffRoundsRoundIdSetupRoute
  '/cohorts/$cohortId/': typeof StaffAreaCohortsCohortIdIndexRoute
  '/cohorts/$cohortId/appels/$appelId': typeof StaffAreaCohortsCohortIdAppelsAppelIdRouteWithChildren
  '/staff/rounds/$roundId/applications/$applicationId': typeof StaffRoundsRoundIdApplicationsApplicationIdRoute
  '/cohorts/$cohortId/appels/$appelId/eligibility': typeof StaffAreaCohortsCohortIdAppelsAppelIdEligibilityRoute
  '/cohorts/$cohortId/appels/$appelId/programme': typeof StaffAreaCohortsCohortIdAppelsAppelIdProgrammeRoute
  '/cohorts/$cohortId/appels/$appelId/': typeof StaffAreaCohortsCohortIdAppelsAppelIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account-recovery': typeof AccountRecoveryRoute
  '/account-security-alert': typeof AccountSecurityAlertRoute
  '/account-setup': typeof AccountSetupRoute
  '/applicant': typeof ApplicantRouteWithChildren
  '/no-access': typeof NoAccessRoute
  '/reset-password': typeof ResetPasswordRoute
  '/staff': typeof StaffRouteWithChildren
  '/verify-email': typeof VerifyEmailRoute
  '/website': typeof WebsiteRoute
  '/account': typeof StaffAreaAccountRoute
  '/question-bank': typeof StaffAreaQuestionBankRoute
  '/team': typeof StaffAreaTeamRoute
  '/applicant/home': typeof ApplicantHomeRoute
  '/apply/$roundId': typeof ApplyRoundIdRoute
  '/rounds/$roundId': typeof RoundsRoundIdRoute
  '/staff/applications': typeof StaffApplicationsRoute
  '/staff/competencies': typeof StaffCompetenciesRoute
  '/staff/dashboard': typeof StaffDashboardRoute
  '/staff/questions': typeof StaffQuestionsRoute
  '/staff/reporting': typeof StaffReportingRoute
  '/staff/rounds': typeof StaffRoundsRoute
  '/staff/settings': typeof StaffSettingsRoute
  '/applicant/applications/$applicationId': typeof ApplicantApplicationsApplicationIdRoute
  '/apply/$roundId/register': typeof ApplyRoundIdRegisterRoute
  '/staff/rounds/create': typeof StaffRoundsCreateRoute
  '/cohorts': typeof StaffAreaCohortsIndexRoute
  '/cohorts/$cohortId/settings': typeof StaffAreaCohortsCohortIdSettingsRoute
  '/applicant/applications/$applicationId/respond': typeof ApplicantApplicationsApplicationIdRespondRoute
  '/staff/rounds/$roundId/applications': typeof StaffRoundsRoundIdApplicationsRoute
  '/staff/rounds/$roundId/queue': typeof StaffRoundsRoundIdQueueRoute
  '/staff/rounds/$roundId/waiting': typeof StaffRoundsRoundIdWaitingRoute
  '/staff/rounds/$roundId/setup': typeof StaffRoundsRoundIdSetupRoute
  '/cohorts/$cohortId': typeof StaffAreaCohortsCohortIdIndexRoute
  '/staff/rounds/$roundId/applications/$applicationId': typeof StaffRoundsRoundIdApplicationsApplicationIdRoute
  '/cohorts/$cohortId/appels/$appelId/eligibility': typeof StaffAreaCohortsCohortIdAppelsAppelIdEligibilityRoute
  '/cohorts/$cohortId/appels/$appelId/programme': typeof StaffAreaCohortsCohortIdAppelsAppelIdProgrammeRoute
  '/cohorts/$cohortId/appels/$appelId': typeof StaffAreaCohortsCohortIdAppelsAppelIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_staff-area': typeof StaffAreaRouteWithChildren
  '/account-recovery': typeof AccountRecoveryRoute
  '/account-security-alert': typeof AccountSecurityAlertRoute
  '/account-setup': typeof AccountSetupRoute
  '/applicant': typeof ApplicantRouteWithChildren
  '/no-access': typeof NoAccessRoute
  '/reset-password': typeof ResetPasswordRoute
  '/staff': typeof StaffRouteWithChildren
  '/verify-email': typeof VerifyEmailRoute
  '/website': typeof WebsiteRoute
  '/_staff-area/account': typeof StaffAreaAccountRoute
  '/_staff-area/question-bank': typeof StaffAreaQuestionBankRoute
  '/_staff-area/team': typeof StaffAreaTeamRoute
  '/applicant/home': typeof ApplicantHomeRoute
  '/apply/$roundId': typeof ApplyRoundIdRoute
  '/rounds/$roundId': typeof RoundsRoundIdRoute
  '/staff/applications': typeof StaffApplicationsRoute
  '/staff/competencies': typeof StaffCompetenciesRoute
  '/staff/dashboard': typeof StaffDashboardRoute
  '/staff/questions': typeof StaffQuestionsRoute
  '/staff/reporting': typeof StaffReportingRoute
  '/staff/rounds': typeof StaffRoundsRoute
  '/staff/settings': typeof StaffSettingsRoute
  '/_staff-area/cohorts/$cohortId': typeof StaffAreaCohortsCohortIdRouteWithChildren
  '/applicant/applications/$applicationId': typeof ApplicantApplicationsApplicationIdRoute
  '/apply_/$roundId/register': typeof ApplyRoundIdRegisterRoute
  '/staff_/rounds/create': typeof StaffRoundsCreateRoute
  '/_staff-area/cohorts/': typeof StaffAreaCohortsIndexRoute
  '/_staff-area/cohorts/$cohortId/settings': typeof StaffAreaCohortsCohortIdSettingsRoute
  '/applicant/applications/$applicationId_/respond': typeof ApplicantApplicationsApplicationIdRespondRoute
  '/staff/rounds_/$roundId/applications': typeof StaffRoundsRoundIdApplicationsRoute
  '/staff/rounds_/$roundId/queue': typeof StaffRoundsRoundIdQueueRoute
  '/staff/rounds_/$roundId/waiting': typeof StaffRoundsRoundIdWaitingRoute
  '/staff_/rounds/$roundId/setup': typeof StaffRoundsRoundIdSetupRoute
  '/_staff-area/cohorts/$cohortId/': typeof StaffAreaCohortsCohortIdIndexRoute
  '/_staff-area/cohorts/$cohortId/appels/$appelId': typeof StaffAreaCohortsCohortIdAppelsAppelIdRouteWithChildren
  '/staff/rounds_/$roundId/applications_/$applicationId': typeof StaffRoundsRoundIdApplicationsApplicationIdRoute
  '/_staff-area/cohorts/$cohortId/appels/$appelId/eligibility': typeof StaffAreaCohortsCohortIdAppelsAppelIdEligibilityRoute
  '/_staff-area/cohorts/$cohortId/appels/$appelId/programme': typeof StaffAreaCohortsCohortIdAppelsAppelIdProgrammeRoute
  '/_staff-area/cohorts/$cohortId/appels/$appelId/': typeof StaffAreaCohortsCohortIdAppelsAppelIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account-recovery'
    | '/account-security-alert'
    | '/account-setup'
    | '/applicant'
    | '/no-access'
    | '/reset-password'
    | '/staff'
    | '/verify-email'
    | '/website'
    | '/account'
    | '/question-bank'
    | '/team'
    | '/applicant/home'
    | '/apply/$roundId'
    | '/rounds/$roundId'
    | '/staff/applications'
    | '/staff/competencies'
    | '/staff/dashboard'
    | '/staff/questions'
    | '/staff/reporting'
    | '/staff/rounds'
    | '/staff/settings'
    | '/cohorts/$cohortId'
    | '/applicant/applications/$applicationId'
    | '/apply/$roundId/register'
    | '/staff/rounds/create'
    | '/cohorts/'
    | '/cohorts/$cohortId/settings'
    | '/applicant/applications/$applicationId/respond'
    | '/staff/rounds/$roundId/applications'
    | '/staff/rounds/$roundId/queue'
    | '/staff/rounds/$roundId/waiting'
    | '/staff/rounds/$roundId/setup'
    | '/cohorts/$cohortId/'
    | '/cohorts/$cohortId/appels/$appelId'
    | '/staff/rounds/$roundId/applications/$applicationId'
    | '/cohorts/$cohortId/appels/$appelId/eligibility'
    | '/cohorts/$cohortId/appels/$appelId/programme'
    | '/cohorts/$cohortId/appels/$appelId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account-recovery'
    | '/account-security-alert'
    | '/account-setup'
    | '/applicant'
    | '/no-access'
    | '/reset-password'
    | '/staff'
    | '/verify-email'
    | '/website'
    | '/account'
    | '/question-bank'
    | '/team'
    | '/applicant/home'
    | '/apply/$roundId'
    | '/rounds/$roundId'
    | '/staff/applications'
    | '/staff/competencies'
    | '/staff/dashboard'
    | '/staff/questions'
    | '/staff/reporting'
    | '/staff/rounds'
    | '/staff/settings'
    | '/applicant/applications/$applicationId'
    | '/apply/$roundId/register'
    | '/staff/rounds/create'
    | '/cohorts'
    | '/cohorts/$cohortId/settings'
    | '/applicant/applications/$applicationId/respond'
    | '/staff/rounds/$roundId/applications'
    | '/staff/rounds/$roundId/queue'
    | '/staff/rounds/$roundId/waiting'
    | '/staff/rounds/$roundId/setup'
    | '/cohorts/$cohortId'
    | '/staff/rounds/$roundId/applications/$applicationId'
    | '/cohorts/$cohortId/appels/$appelId/eligibility'
    | '/cohorts/$cohortId/appels/$appelId/programme'
    | '/cohorts/$cohortId/appels/$appelId'
  id:
    | '__root__'
    | '/'
    | '/_staff-area'
    | '/account-recovery'
    | '/account-security-alert'
    | '/account-setup'
    | '/applicant'
    | '/no-access'
    | '/reset-password'
    | '/staff'
    | '/verify-email'
    | '/website'
    | '/_staff-area/account'
    | '/_staff-area/question-bank'
    | '/_staff-area/team'
    | '/applicant/home'
    | '/apply/$roundId'
    | '/rounds/$roundId'
    | '/staff/applications'
    | '/staff/competencies'
    | '/staff/dashboard'
    | '/staff/questions'
    | '/staff/reporting'
    | '/staff/rounds'
    | '/staff/settings'
    | '/_staff-area/cohorts/$cohortId'
    | '/applicant/applications/$applicationId'
    | '/apply_/$roundId/register'
    | '/staff_/rounds/create'
    | '/_staff-area/cohorts/'
    | '/_staff-area/cohorts/$cohortId/settings'
    | '/applicant/applications/$applicationId_/respond'
    | '/staff/rounds_/$roundId/applications'
    | '/staff/rounds_/$roundId/queue'
    | '/staff/rounds_/$roundId/waiting'
    | '/staff_/rounds/$roundId/setup'
    | '/_staff-area/cohorts/$cohortId/'
    | '/_staff-area/cohorts/$cohortId/appels/$appelId'
    | '/staff/rounds_/$roundId/applications_/$applicationId'
    | '/_staff-area/cohorts/$cohortId/appels/$appelId/eligibility'
    | '/_staff-area/cohorts/$cohortId/appels/$appelId/programme'
    | '/_staff-area/cohorts/$cohortId/appels/$appelId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  StaffAreaRoute: typeof StaffAreaRouteWithChildren
  AccountRecoveryRoute: typeof AccountRecoveryRoute
  AccountSecurityAlertRoute: typeof AccountSecurityAlertRoute
  AccountSetupRoute: typeof AccountSetupRoute
  ApplicantRoute: typeof ApplicantRouteWithChildren
  NoAccessRoute: typeof NoAccessRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  StaffRoute: typeof StaffRouteWithChildren
  VerifyEmailRoute: typeof VerifyEmailRoute
  WebsiteRoute: typeof WebsiteRoute
  ApplyRoundIdRoute: typeof ApplyRoundIdRoute
  RoundsRoundIdRoute: typeof RoundsRoundIdRoute
  ApplyRoundIdRegisterRoute: typeof ApplyRoundIdRegisterRoute
  StaffRoundsCreateRoute: typeof StaffRoundsCreateRoute
  StaffRoundsRoundIdSetupRoute: typeof StaffRoundsRoundIdSetupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_staff-area': {
      id: '/_staff-area'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof StaffAreaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-recovery': {
      id: '/account-recovery'
      path: '/account-recovery'
      fullPath: '/account-recovery'
      preLoaderRoute: typeof AccountRecoveryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-security-alert': {
      id: '/account-security-alert'
      path: '/account-security-alert'
      fullPath: '/account-security-alert'
      preLoaderRoute: typeof AccountSecurityAlertRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-setup': {
      id: '/account-setup'
      path: '/account-setup'
      fullPath: '/account-setup'
      preLoaderRoute: typeof AccountSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/applicant': {
      id: '/applicant'
      path: '/applicant'
      fullPath: '/applicant'
      preLoaderRoute: typeof ApplicantRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-access': {
      id: '/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof NoAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff': {
      id: '/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof StaffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/website': {
      id: '/website'
      path: '/website'
      fullPath: '/website'
      preLoaderRoute: typeof WebsiteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_staff-area/account': {
      id: '/_staff-area/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof StaffAreaAccountRouteImport
      parentRoute: typeof StaffAreaRoute
    }
    '/_staff-area/question-bank': {
      id: '/_staff-area/question-bank'
      path: '/question-bank'
      fullPath: '/question-bank'
      preLoaderRoute: typeof StaffAreaQuestionBankRouteImport
      parentRoute: typeof StaffAreaRoute
    }
    '/_staff-area/team': {
      id: '/_staff-area/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof StaffAreaTeamRouteImport
      parentRoute: typeof StaffAreaRoute
    }
    '/applicant/home': {
      id: '/applicant/home'
      path: '/home'
      fullPath: '/applicant/home'
      preLoaderRoute: typeof ApplicantHomeRouteImport
      parentRoute: typeof ApplicantRoute
    }
    '/apply/$roundId': {
      id: '/apply/$roundId'
      path: '/apply/$roundId'
      fullPath: '/apply/$roundId'
      preLoaderRoute: typeof ApplyRoundIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rounds/$roundId': {
      id: '/rounds/$roundId'
      path: '/rounds/$roundId'
      fullPath: '/rounds/$roundId'
      preLoaderRoute: typeof RoundsRoundIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff/applications': {
      id: '/staff/applications'
      path: '/applications'
      fullPath: '/staff/applications'
      preLoaderRoute: typeof StaffApplicationsRouteImport
      parentRoute: typeof StaffRoute
    }
    '/staff/competencies': {
      id: '/staff/competencies'
      path: '/competencies'
      fullPath: '/staff/competencies'
      preLoaderRoute: typeof StaffCompetenciesRouteImport
      parentRoute: typeof StaffRoute
    }
    '/staff/dashboard': {
      id: '/staff/dashboard'
      path: '/dashboard'
      fullPath: '/staff/dashboard'
      preLoaderRoute: typeof StaffDashboardRouteImport
      parentRoute: typeof StaffRoute
    }
    '/staff/questions': {
      id: '/staff/questions'
      path: '/questions'
      fullPath: '/staff/questions'
      preLoaderRoute: typeof StaffQuestionsRouteImport
      parentRoute: typeof StaffRoute
    }
    '/staff/reporting': {
      id: '/staff/reporting'
      path: '/reporting'
      fullPath: '/staff/reporting'
      preLoaderRoute: typeof StaffReportingRouteImport
      parentRoute: typeof StaffRoute
    }
    '/staff/rounds': {
      id: '/staff/rounds'
      path: '/rounds'
      fullPath: '/staff/rounds'
      preLoaderRoute: typeof StaffRoundsRouteImport
      parentRoute: typeof StaffRoute
    }
    '/staff/settings': {
      id: '/staff/settings'
      path: '/settings'
      fullPath: '/staff/settings'
      preLoaderRoute: typeof StaffSettingsRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff-area/cohorts/': {
      id: '/_staff-area/cohorts/'
      path: '/cohorts'
      fullPath: '/cohorts/'
      preLoaderRoute: typeof StaffAreaCohortsIndexRouteImport
      parentRoute: typeof StaffAreaRoute
    }
    '/_staff-area/cohorts/$cohortId': {
      id: '/_staff-area/cohorts/$cohortId'
      path: '/cohorts/$cohortId'
      fullPath: '/cohorts/$cohortId'
      preLoaderRoute: typeof StaffAreaCohortsCohortIdRouteImport
      parentRoute: typeof StaffAreaRoute
    }
    '/applicant/applications/$applicationId': {
      id: '/applicant/applications/$applicationId'
      path: '/applications/$applicationId'
      fullPath: '/applicant/applications/$applicationId'
      preLoaderRoute: typeof ApplicantApplicationsApplicationIdRouteImport
      parentRoute: typeof ApplicantRoute
    }
    '/apply_/$roundId/register': {
      id: '/apply_/$roundId/register'
      path: '/apply/$roundId/register'
      fullPath: '/apply/$roundId/register'
      preLoaderRoute: typeof ApplyRoundIdRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff_/rounds/create': {
      id: '/staff_/rounds/create'
      path: '/staff/rounds/create'
      fullPath: '/staff/rounds/create'
      preLoaderRoute: typeof StaffRoundsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_staff-area/cohorts/$cohortId/': {
      id: '/_staff-area/cohorts/$cohortId/'
      path: '/'
      fullPath: '/cohorts/$cohortId/'
      preLoaderRoute: typeof StaffAreaCohortsCohortIdIndexRouteImport
      parentRoute: typeof StaffAreaCohortsCohortIdRoute
    }
    '/_staff-area/cohorts/$cohortId/settings': {
      id: '/_staff-area/cohorts/$cohortId/settings'
      path: '/settings'
      fullPath: '/cohorts/$cohortId/settings'
      preLoaderRoute: typeof StaffAreaCohortsCohortIdSettingsRouteImport
      parentRoute: typeof StaffAreaCohortsCohortIdRoute
    }
    '/applicant/applications/$applicationId_/respond': {
      id: '/applicant/applications/$applicationId_/respond'
      path: '/applications/$applicationId/respond'
      fullPath: '/applicant/applications/$applicationId/respond'
      preLoaderRoute: typeof ApplicantApplicationsApplicationIdRespondRouteImport
      parentRoute: typeof ApplicantRoute
    }
    '/staff/rounds_/$roundId/applications': {
      id: '/staff/rounds_/$roundId/applications'
      path: '/rounds/$roundId/applications'
      fullPath: '/staff/rounds/$roundId/applications'
      preLoaderRoute: typeof StaffRoundsRoundIdApplicationsRouteImport
      parentRoute: typeof StaffRoute
    }
    '/staff/rounds_/$roundId/queue': {
      id: '/staff/rounds_/$roundId/queue'
      path: '/rounds/$roundId/queue'
      fullPath: '/staff/rounds/$roundId/queue'
      preLoaderRoute: typeof StaffRoundsRoundIdQueueRouteImport
      parentRoute: typeof StaffRoute
    }
    '/staff/rounds_/$roundId/waiting': {
      id: '/staff/rounds_/$roundId/waiting'
      path: '/rounds/$roundId/waiting'
      fullPath: '/staff/rounds/$roundId/waiting'
      preLoaderRoute: typeof StaffRoundsRoundIdWaitingRouteImport
      parentRoute: typeof StaffRoute
    }
    '/staff_/rounds/$roundId/setup': {
      id: '/staff_/rounds/$roundId/setup'
      path: '/staff/rounds/$roundId/setup'
      fullPath: '/staff/rounds/$roundId/setup'
      preLoaderRoute: typeof StaffRoundsRoundIdSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_staff-area/cohorts/$cohortId/appels/$appelId': {
      id: '/_staff-area/cohorts/$cohortId/appels/$appelId'
      path: '/appels/$appelId'
      fullPath: '/cohorts/$cohortId/appels/$appelId'
      preLoaderRoute: typeof StaffAreaCohortsCohortIdAppelsAppelIdRouteImport
      parentRoute: typeof StaffAreaCohortsCohortIdRoute
    }
    '/staff/rounds_/$roundId/applications_/$applicationId': {
      id: '/staff/rounds_/$roundId/applications_/$applicationId'
      path: '/rounds/$roundId/applications/$applicationId'
      fullPath: '/staff/rounds/$roundId/applications/$applicationId'
      preLoaderRoute: typeof StaffRoundsRoundIdApplicationsApplicationIdRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_staff-area/cohorts/$cohortId/appels/$appelId/': {
      id: '/_staff-area/cohorts/$cohortId/appels/$appelId/'
      path: '/'
      fullPath: '/cohorts/$cohortId/appels/$appelId/'
      preLoaderRoute: typeof StaffAreaCohortsCohortIdAppelsAppelIdIndexRouteImport
      parentRoute: typeof StaffAreaCohortsCohortIdAppelsAppelIdRoute
    }
    '/_staff-area/cohorts/$cohortId/appels/$appelId/eligibility': {
      id: '/_staff-area/cohorts/$cohortId/appels/$appelId/eligibility'
      path: '/eligibility'
      fullPath: '/cohorts/$cohortId/appels/$appelId/eligibility'
      preLoaderRoute: typeof StaffAreaCohortsCohortIdAppelsAppelIdEligibilityRouteImport
      parentRoute: typeof StaffAreaCohortsCohortIdAppelsAppelIdRoute
    }
    '/_staff-area/cohorts/$cohortId/appels/$appelId/programme': {
      id: '/_staff-area/cohorts/$cohortId/appels/$appelId/programme'
      path: '/programme'
      fullPath: '/cohorts/$cohortId/appels/$appelId/programme'
      preLoaderRoute: typeof StaffAreaCohortsCohortIdAppelsAppelIdProgrammeRouteImport
      parentRoute: typeof StaffAreaCohortsCohortIdAppelsAppelIdRoute
    }
  }
}

interface StaffAreaCohortsCohortIdAppelsAppelIdRouteChildren {
  StaffAreaCohortsCohortIdAppelsAppelIdEligibilityRoute: typeof StaffAreaCohortsCohortIdAppelsAppelIdEligibilityRoute
  StaffAreaCohortsCohortIdAppelsAppelIdProgrammeRoute: typeof StaffAreaCohortsCohortIdAppelsAppelIdProgrammeRoute
  StaffAreaCohortsCohortIdAppelsAppelIdIndexRoute: typeof StaffAreaCohortsCohortIdAppelsAppelIdIndexRoute
}

const StaffAreaCohortsCohortIdAppelsAppelIdRouteChildren: StaffAreaCohortsCohortIdAppelsAppelIdRouteChildren =
  {
    StaffAreaCohortsCohortIdAppelsAppelIdEligibilityRoute:
      StaffAreaCohortsCohortIdAppelsAppelIdEligibilityRoute,
    StaffAreaCohortsCohortIdAppelsAppelIdProgrammeRoute:
      StaffAreaCohortsCohortIdAppelsAppelIdProgrammeRoute,
    StaffAreaCohortsCohortIdAppelsAppelIdIndexRoute:
      StaffAreaCohortsCohortIdAppelsAppelIdIndexRoute,
  }

const StaffAreaCohortsCohortIdAppelsAppelIdRouteWithChildren =
  StaffAreaCohortsCohortIdAppelsAppelIdRoute._addFileChildren(
    StaffAreaCohortsCohortIdAppelsAppelIdRouteChildren,
  )

interface StaffAreaCohortsCohortIdRouteChildren {
  StaffAreaCohortsCohortIdSettingsRoute: typeof StaffAreaCohortsCohortIdSettingsRoute
  StaffAreaCohortsCohortIdIndexRoute: typeof StaffAreaCohortsCohortIdIndexRoute
  StaffAreaCohortsCohortIdAppelsAppelIdRoute: typeof StaffAreaCohortsCohortIdAppelsAppelIdRouteWithChildren
}

const StaffAreaCohortsCohortIdRouteChildren: StaffAreaCohortsCohortIdRouteChildren =
  {
    StaffAreaCohortsCohortIdSettingsRoute:
      StaffAreaCohortsCohortIdSettingsRoute,
    StaffAreaCohortsCohortIdIndexRoute: StaffAreaCohortsCohortIdIndexRoute,
    StaffAreaCohortsCohortIdAppelsAppelIdRoute:
      StaffAreaCohortsCohortIdAppelsAppelIdRouteWithChildren,
  }

const StaffAreaCohortsCohortIdRouteWithChildren =
  StaffAreaCohortsCohortIdRoute._addFileChildren(
    StaffAreaCohortsCohortIdRouteChildren,
  )

interface StaffAreaRouteChildren {
  StaffAreaAccountRoute: typeof StaffAreaAccountRoute
  StaffAreaQuestionBankRoute: typeof StaffAreaQuestionBankRoute
  StaffAreaTeamRoute: typeof StaffAreaTeamRoute
  StaffAreaCohortsCohortIdRoute: typeof StaffAreaCohortsCohortIdRouteWithChildren
  StaffAreaCohortsIndexRoute: typeof StaffAreaCohortsIndexRoute
}

const StaffAreaRouteChildren: StaffAreaRouteChildren = {
  StaffAreaAccountRoute: StaffAreaAccountRoute,
  StaffAreaQuestionBankRoute: StaffAreaQuestionBankRoute,
  StaffAreaTeamRoute: StaffAreaTeamRoute,
  StaffAreaCohortsCohortIdRoute: StaffAreaCohortsCohortIdRouteWithChildren,
  StaffAreaCohortsIndexRoute: StaffAreaCohortsIndexRoute,
}

const StaffAreaRouteWithChildren = StaffAreaRoute._addFileChildren(
  StaffAreaRouteChildren,
)

interface ApplicantRouteChildren {
  ApplicantHomeRoute: typeof ApplicantHomeRoute
  ApplicantApplicationsApplicationIdRoute: typeof ApplicantApplicationsApplicationIdRoute
  ApplicantApplicationsApplicationIdRespondRoute: typeof ApplicantApplicationsApplicationIdRespondRoute
}

const ApplicantRouteChildren: ApplicantRouteChildren = {
  ApplicantHomeRoute: ApplicantHomeRoute,
  ApplicantApplicationsApplicationIdRoute:
    ApplicantApplicationsApplicationIdRoute,
  ApplicantApplicationsApplicationIdRespondRoute:
    ApplicantApplicationsApplicationIdRespondRoute,
}

const ApplicantRouteWithChildren = ApplicantRoute._addFileChildren(
  ApplicantRouteChildren,
)

interface StaffRouteChildren {
  StaffApplicationsRoute: typeof StaffApplicationsRoute
  StaffCompetenciesRoute: typeof StaffCompetenciesRoute
  StaffDashboardRoute: typeof StaffDashboardRoute
  StaffQuestionsRoute: typeof StaffQuestionsRoute
  StaffReportingRoute: typeof StaffReportingRoute
  StaffRoundsRoute: typeof StaffRoundsRoute
  StaffSettingsRoute: typeof StaffSettingsRoute
  StaffRoundsRoundIdApplicationsRoute: typeof StaffRoundsRoundIdApplicationsRoute
  StaffRoundsRoundIdQueueRoute: typeof StaffRoundsRoundIdQueueRoute
  StaffRoundsRoundIdWaitingRoute: typeof StaffRoundsRoundIdWaitingRoute
  StaffRoundsRoundIdApplicationsApplicationIdRoute: typeof StaffRoundsRoundIdApplicationsApplicationIdRoute
}

const StaffRouteChildren: StaffRouteChildren = {
  StaffApplicationsRoute: StaffApplicationsRoute,
  StaffCompetenciesRoute: StaffCompetenciesRoute,
  StaffDashboardRoute: StaffDashboardRoute,
  StaffQuestionsRoute: StaffQuestionsRoute,
  StaffReportingRoute: StaffReportingRoute,
  StaffRoundsRoute: StaffRoundsRoute,
  StaffSettingsRoute: StaffSettingsRoute,
  StaffRoundsRoundIdApplicationsRoute: StaffRoundsRoundIdApplicationsRoute,
  StaffRoundsRoundIdQueueRoute: StaffRoundsRoundIdQueueRoute,
  StaffRoundsRoundIdWaitingRoute: StaffRoundsRoundIdWaitingRoute,
  StaffRoundsRoundIdApplicationsApplicationIdRoute:
    StaffRoundsRoundIdApplicationsApplicationIdRoute,
}

const StaffRouteWithChildren = StaffRoute._addFileChildren(StaffRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  StaffAreaRoute: StaffAreaRouteWithChildren,
  AccountRecoveryRoute: AccountRecoveryRoute,
  AccountSecurityAlertRoute: AccountSecurityAlertRoute,
  AccountSetupRoute: AccountSetupRoute,
  ApplicantRoute: ApplicantRouteWithChildren,
  NoAccessRoute: NoAccessRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  StaffRoute: StaffRouteWithChildren,
  VerifyEmailRoute: VerifyEmailRoute,
  WebsiteRoute: WebsiteRoute,
  ApplyRoundIdRoute: ApplyRoundIdRoute,
  RoundsRoundIdRoute: RoundsRoundIdRoute,
  ApplyRoundIdRegisterRoute: ApplyRoundIdRegisterRoute,
  StaffRoundsCreateRoute: StaffRoundsCreateRoute,
  StaffRoundsRoundIdSetupRoute: StaffRoundsRoundIdSetupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
